import brandPortalOrders from "@faire/web-api/routes/brand-portal/orders";
import brandPortalOrdersbrandOrderTokenEdit from "@faire/web-api/routes/brand-portal/orders/brandOrderToken/edit";
import { Button } from "@faire/web/slate/Button";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { Bold } from "../common/Bold";
export var AddOrEditItemsIA = function AddOrEditItemsIA(_ref) {
  var _context$brandOrder, _context$brandOrder$b;
  var context = _ref.context;
  var brandOrderToken = (_context$brandOrder = context.brandOrder) === null || _context$brandOrder === void 0 ? void 0 : (_context$brandOrder$b = _context$brandOrder.brand_order) === null || _context$brandOrder$b === void 0 ? void 0 : _context$brandOrder$b.token;
  if (brandOrderToken) {
    return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "7fDMID",
      defaultMessage: [{
        "type": 0,
        "value": "Pour ajouter ou modifier des produits dans une commande, accédez d'abord à la "
      }, {
        "children": [{
          "type": 0,
          "value": "page des détails de la commande"
        }],
        "type": 8,
        "value": "OrderDetailsLinkFormatting"
      }, {
        "type": 0,
        "value": ". Ensuite, sélectionnez "
      }, {
        "children": [{
          "type": 0,
          "value": "Modifier la commande"
        }],
        "type": 8,
        "value": "LinkFormatting"
      }, {
        "type": 0,
        "value": "."
      }],
      values: {
        LinkFormatting: function LinkFormatting(chunks) {
          return EditOrderLinkFormatting(chunks, brandOrderToken);
        },
        OrderDetailsLinkFormatting: function OrderDetailsLinkFormatting(chunks) {
          return orderDetailsLinkFormatting(chunks);
        }
      }
    })), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "ab3w4/",
      defaultMessage: [{
        "type": 0,
        "value": "Vous pouvez ajouter des produits en cliquant sur le bouton "
      }, {
        "children": [{
          "type": 0,
          "value": "Ajouter un produit"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": ", et les supprimer en cliquant sur l'icône de la corbeille à côté de chaque article. Vous pouvez modifier les quantités d'articles en modifiant le nombre dans la colonne "
      }, {
        "children": [{
          "type": 0,
          "value": "Qté"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": "."
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    })), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "UjBG6x",
      defaultMessage: [{
        "type": 0,
        "value": "Après avoir effectué vos modifications, cliquez sur "
      }, {
        "children": [{
          "type": 0,
          "value": "Mettre à jour"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": " pour les enregistrer. Vous avez également la possibilité de laisser un message au commerçant. Nous vous recommandons vivement de l'informer de ce qu'il se passe avec sa commande. Le commerçant recevra une notification par e-mail détaillant les modifications."
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    })));
  } else {
    return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "Sdx3lz",
      defaultMessage: [{
        "type": 0,
        "value": "Pour ajouter ou modifier des produits dans une commande, accédez d'abord à vos "
      }, {
        "children": [{
          "type": 0,
          "value": "Commandes"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": ", puis accédez à la "
      }, {
        "children": [{
          "type": 0,
          "value": "page des détails de la commande"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": " que vous souhaitez modifier. Ensuite, sélectionnez "
      }, {
        "children": [{
          "type": 0,
          "value": "Modifier la commande"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": "."
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    })), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "Un5qc8",
      defaultMessage: [{
        "type": 0,
        "value": "Vous pouvez ajouter des produits en cliquant sur le bouton "
      }, {
        "children": [{
          "type": 0,
          "value": "Ajouter un produit"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": ", et les supprimer en cliquant sur l'icône de la corbeille à côté de chaque article. Vous pouvez modifier les quantités d'articles en modifiant le nombre dans la colonne "
      }, {
        "children": [{
          "type": 0,
          "value": "Qté"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": "."
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    })), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "lyNjZ+",
      defaultMessage: [{
        "type": 0,
        "value": "Après avoir effectué vos modifications, cliquez sur "
      }, {
        "children": [{
          "type": 0,
          "value": "Mettre à jour"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": " pour les enregistrer. Vous avez également la possibilité de laisser un message au commerçant. Nous vous recommandons vivement de l'informer de la mise à jour de sa commande. Le commerçant recevra une notification par e-mail détaillant les modifications."
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    })));
  }
};
var EditOrderLinkFormatting = function EditOrderLinkFormatting(chunks, brandOrderToken) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: brandPortalOrdersbrandOrderTokenEdit(brandOrderToken),
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Bold, null, chunks));
};
var orderDetailsLinkFormatting = function orderDetailsLinkFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: brandPortalOrders(),
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Bold, null, chunks));
};
var _BoldFormatting = function _BoldFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Bold, null, chunks);
};